import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-9" }
const _hoisted_3 = { class: "col-xxl-3" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "col-xxl-9" }
const _hoisted_7 = { class: "col-xxl-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-6 col-xxl-12" }
const _hoisted_10 = { class: "col-sm-6 col-xxl-12" }
const _hoisted_11 = { class: "col-lg-4" }
const _hoisted_12 = { class: "col-lg-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SAWelcome = _resolveComponent("SAWelcome")!
  const _component_Stats = _resolveComponent("Stats")!
  const _component_CustomerVisits = _resolveComponent("CustomerVisits")!
  const _component_TopSellingProducts = _resolveComponent("TopSellingProducts")!
  const _component_GrossRevenue = _resolveComponent("GrossRevenue")!
  const _component_RecentSales = _resolveComponent("RecentSales")!
  const _component_SalesByGenderChart = _resolveComponent("SalesByGenderChart")!
  const _component_SalesThisMonthChart = _resolveComponent("SalesThisMonthChart")!
  const _component_SalesByCategoryChart = _resolveComponent("SalesByCategoryChart")!
  const _component_StockAlerts = _resolveComponent("StockAlerts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SAWelcome),
      _createVNode(_component_Stats)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CustomerVisits)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_TopSellingProducts)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_GrossRevenue)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_RecentSales)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_SalesByGenderChart)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_SalesThisMonthChart)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_SalesByCategoryChart)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_StockAlerts)
    ])
  ]))
}